import React, { useState } from "react";
import { Col, Row, Form } from "react-bootstrap";

import SaveChanges from "./SaveChanges";

export default function PlatformSpecific(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
  const [semrushApiKey, setSemrushApiKey] = useState(props.organization.semrush_api_key);

  return (
    <>
      <Row className="d-flex mx-0 pt-4 pl-4 pr-md-4 pr-0 pb-0 trim-padding">
        <Col className="pl-md-4 pl-0 mb-5 pb-2 pr-0 pr-md-3 basic-info-container prim-bg" xs={12} >
          <div className="pt-4 pb-2 mb-3 px-3">
            <h5>Platform specific data</h5>
          </div>
          <div style={{ maxWidth: "900px", justifyContent: "center", margin: "0 auto" }} className="mt-5 mb-5 px-3">
            <Form id="platform-specific-data" method="post" action="/datapulse/api-access">
              <input hidden name="authenticity_token" value={authenticityToken} readOnly />
              <input hidden name="org_id" value={props.organization.id} readOnly />
              <Row>
                <Col xs={12} style={{ marginBottom: "20px" }}>
                  <div style={{paddingBottom: "5px"}}>
                    <h5 className="d-inline pl-1" style={{ fontSize: "15px" }}>
                      Google Ads MCC ID (No '-'s):
                    </h5>
                    <span className={props.showAlert === true ? "d-inline ml-3 mcc-alert-text" : "d-none"}>
                      Please enter 10 digit MCC ID without dashes or spaces before continuing
                    </span>
                  </div>
                  <Form.Control
                    placeholder="Enter MCC ID"
                    value={props.mccId ? props.mccId : ""}
                    onChange={(e) => props.setMccId(e.target.value)}
                    name="google_ads_mcc_id"
                    className={props.showAlert === true ? "mcc-alert" : ""}
                  />
                </Col>
                <Col xs={12}>
                  <h5 style={{ fontSize: "15px" }} className="pl-1">
                    SEMRush API Key:
                  </h5>
                  <Form.Control
                    placeholder="Enter SEMRush API Key"
                    value={semrushApiKey ? semrushApiKey : ""}
                    onChange={(e) => setSemrushApiKey(e.target.value)}
                    name="semrush_api_key"
                  />
                </Col>
              </Row>
              <Row className="justify-content-end">
                <Col className="api-access-col">
                  <SaveChanges />
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
}
